<template>
  <div class="container">
    <div class="clearfix">
      <div class="back_box">
        <!-- <img src="@/assets/images/icons/icon_back.png" alt="" /> -->
        <el-button
          class="back-btn"
          type="text"
          icon="el-icon-arrow-left"
          @click="$router.go(-1)"
          >返回</el-button
        >
      </div>
      <el-button
        class="end_btn"
        type="primary"
        round
        v-show="info.status != 'STOP'"
        @click="handleStop"
        >结束活动</el-button
      >
    </div>
    <div class="main">
      <div class="topic">
        <div class="top">
          <span class="time">{{
            formatDate(info.startTime, "MM-DD HH:mm")
          }}</span>
          <span class="surplus" v-show="info.autoStop && info.status != 'STOP'"
            >剩余<i class="el-icon-time"></i>{{ surplus }}</span
          >
          <span class="end" v-show="info.status == 'STOP'">已结束</span>
          <el-dropdown class="op" @command="topicCommand">
            <span class="el-dropdown-link">
              <i class="el-icon-more"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="edit">编辑</el-dropdown-item>
              <el-dropdown-item command="delete">删除</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div class="content">
          <p v-if="!showEdit" v-html="info.name"></p>
          <div v-else>
            <editor
              :outContent="info.name"
              @content="updateContent"
              height="200px"
              placeholder="请输入讨论主题"
            />

            <div class="btn_row">
              <el-button
                round
                @click="showEdit = false"
                style="margin-right: 30px; width: 90px"
                >取消</el-button
              >
              <el-button
                type="primary"
                round
                @click="handleEdit"
                style="width: 90px"
                >确定</el-button
              >
            </div>
          </div>
        </div>
      </div>
      <div class="floors">
        <div class="reply_title">
          <span
            >共<b style="color: #181e33; margin: 0 5px">{{ list.length }}</b
            >条话题</span
          >
          <!-- <el-dropdown class="op_sort" @command="handleCommand">
            <span class="el-dropdown-link">
              <i class="el-icon-s-operation"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                class="sort_item"
                :class="{ active: currentSort == item.value }"
                :command="item.value"
                v-for="item in sortTitle"
                :key="item.value"
                ><i
                  class="el-icon-check"
                  :class="{ show: currentSort == item.value }"
                ></i
                >{{ item.label }}</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown> -->
        </div>
        <div class="reply_list">
          <div class="reply_item" v-for="item in list" :key="item.discussId">
            <div class="noticeDetail_info">
              <p>
                <el-image
                  class="avatar"
                  :src="item.avatar"
                  fit="cover"
                ></el-image>
                <span class="name">{{ item.nickName }}</span>
                <el-tag
                  v-show="item.top"
                  type="danger"
                  effect="dark"
                  size="mini"
                  style="margin-left: 10px"
                  >顶</el-tag
                >
              </p>
              <div class="notice_interactive">
                <span style="margin-right: 30px">
                  <i
                    class="el-icon-thumb icon"
                    :class="{ like: item.praised }"
                    @click="handlePraised(item)"
                  ></i>
                  <span class="num">{{ item.star }}</span>
                </span>
                <span style="margin-right: 30px">
                  <i
                    class="el-icon-chat-dot-round icon"
                    @click="currentReplyId = item.discussId"
                  ></i>
                  <span class="num">{{
                    item.children ? item.children.length : 0
                  }}</span>
                </span>
                <el-dropdown class="op" @command="replyCommand">
                  <span class="el-dropdown-link">
                    <i class="el-icon-more icon"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item
                      :command="{ val: 0, discussId: item.discussId }"
                      v-show="myId == item.userId"
                      >编辑</el-dropdown-item
                    >
                    <el-dropdown-item
                      :command="{ val: 1, discussId: item.discussId }"
                      >删除</el-dropdown-item
                    >
                    <el-dropdown-item
                      :command="{ val: 2, discussId: item.discussId }"
                      v-show="!item.top"
                      >置顶</el-dropdown-item
                    >
                    <el-dropdown-item
                      :command="{ val: 3, discussId: item.discussId }"
                      v-show="item.top"
                      >取消置顶</el-dropdown-item
                    >
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </div>
            <div class="noticeReply_right">
              <p class="other_info">
                <span class="floor">第{{ item.level }}楼</span>
                <span>{{ formatTime(item.createTime) }}</span>
              </p>
              <div class="reply_content">
                <p v-if="!currentEditReplyId">{{ item.msg }}</p>
                <div v-else-if="currentEditReplyId == item.discussId">
                  <el-input
                    v-model="item.msg"
                    type="textarea"
                    resize="none"
                    :autosize="{ minRows: 3 }"
                    placeholder="请填写讨论内容"
                  ></el-input>
                  <div class="btn_row">
                    <el-button
                      round
                      @click="currentEditReplyId = null"
                      style="margin-right: 30px; width: 90px"
                      >取消</el-button
                    >
                    <el-button
                      type="primary"
                      round
                      @click="handleEditReply(item)"
                      style="width: 90px"
                      >确定</el-button
                    >
                  </div>
                </div>
              </div>
              <div class="replyReply_container">
                <div
                  class="replyReply"
                  v-for="r in item.children"
                  :key="r.discussId"
                >
                  <p class="replyReplyer">
                    {{ r.nickName }}
                    <span v-if="r.toDiscussId">{{
                      filterName(r.toDiscussId)
                    }}</span>
                  </p>
                  <div class="replyReply_content">
                    <p v-if="!currentEditReplyId">{{ r.msg }}</p>
                    <div v-else-if="currentEditReplyId == r.discussId">
                      <el-input
                        v-model="r.msg"
                        type="textarea"
                        resize="none"
                        :autosize="{ minRows: 3 }"
                        placeholder="请填写讨论内容"
                      ></el-input>
                      <div class="btn_row">
                        <el-button
                          round
                          @click="currentEditReplyId = null"
                          style="margin-right: 30px; width: 90px"
                          >取消</el-button
                        >
                        <el-button
                          type="primary"
                          round
                          @click="handleEditReply(r)"
                          style="width: 90px"
                          >确定</el-button
                        >
                      </div>
                    </div>
                  </div>
                  <div class="info_row">
                    <span class="time">{{ formatTime(r.createTime) }}</span>
                    <div class="btns">
                      <el-button
                        type="text"
                        v-show="myId == r.userId"
                        @click="currentEditReplyId = r.discussId"
                        >编辑</el-button
                      >
                      <el-button type="text" @click="handelDel(r.discussId)"
                        >删除</el-button
                      >
                      <el-button
                        type="text"
                        @click="currentReplyId = r.discussId"
                        >回复</el-button
                      >
                    </div>
                  </div>
                  <div
                    class="reply_edit in_floor"
                    v-if="currentReplyId == r.discussId"
                  >
                    <el-input
                      v-model="replyReply"
                      type="textarea"
                      resize="none"
                      :autosize="{ minRows: 3 }"
                      :placeholder="'回复 ' + r.nickName + ':'"
                    ></el-input>
                    <div class="btn_row">
                      <el-button
                        round
                        @click="currentReplyId = null"
                        style="margin-right: 30px; width: 90px"
                        >取消</el-button
                      >
                      <el-button
                        type="primary"
                        round
                        @click="handleReply(r, true)"
                        style="width: 90px"
                        >回复</el-button
                      >
                    </div>
                  </div>
                </div>
                <div class="reply_edit" v-if="currentReplyId == item.discussId">
                  <el-input
                    v-model="reply"
                    type="textarea"
                    resize="none"
                    :autosize="{ minRows: 3 }"
                    :placeholder="'回复 ' + item.nickName + ':'"
                  ></el-input>
                  <div class="btn_row">
                    <el-button
                      round
                      @click="currentReplyId = null"
                      style="margin-right: 30px; width: 90px"
                      >取消</el-button
                    >
                    <el-button
                      type="primary"
                      round
                      @click="handleReply(item)"
                      style="width: 90px"
                      >回复</el-button
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="edit_container">
        <h3 class="edit_headTitle">回复话题</h3>
        <el-input
          v-model="replyTopic.msg"
          type="textarea"
          resize="none"
          :autosize="{ minRows: 5 }"
          placeholder="回复话题"
        ></el-input>
        <div class="btn_row">
          <el-button
            round
            @click="replyTopic.msg = ''"
            style="margin-right: 30px; width: 90px"
            >取消</el-button
          >
          <el-button
            type="primary"
            round
            @click="handleReplyTopic"
            style="width: 90px"
            >回复</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mixinsData from "../mixins/detail";
import editor from "@/components/editor";

import {
  discussList,
  delDiscuss,
  editDiscuss,
  replyDiscuss,
  starDiscuss,
  cancelStarDiscuss,
  topDiscuss,
} from "@/api/activity/discuss";
import { delActivity, editActivity } from "@/api/activity";
import { formatDate, formatTime } from "@/utils/index";
import { handleTree } from "@/utils";

export default {
  name: "discuss",
  mixins: [mixinsData],
  components: {
    editor,
  },
  data() {
    return {
      formatDate,
      formatTime,
      surplus: "",
      orginList: [],
      list: [],
      sortTitle: [
        { value: 0, label: "时间顺序" },
        { value: 1, label: "时间倒序" },
        { value: 2, label: "按点赞数" },
      ],
      currentSort: 1,
      currentReplyId: null,
      reply: "",
      replyReply: "",
      replyTopic: {
        activityId: this.$route.query.activityId,
        msg: "",
      },
      showEdit: false,
      currentEditReplyId: null,
    };
  },
  computed: {
    myId() {
      return this.$store.state.myInfo.userId;
    },
  },
  methods: {
    updateContent(val) {
      this.info.name = val;
    },
    // 讨论列表
    getList() {
      // this.$loading.show();
      let activityId = this.$route.query.activityId;
      discussList({ activityId }).then((res) => {
        // this.$loading.hide();
        if (res.code == 0) {
          this.orginList = res.data;
          this.list = handleTree(res.data, "discussId");
        } else {
          console.log(res.msg);
        }
      });
    },
    topicCommand(command) {
      if (command == "edit") {
        this.showEdit = true;
      } else if (command == "delete") {
        this.$confirm(`确定要删除该活动吗？`, {
          type: "warning",
        })
          .then(() => {
            this.info.status = "STOP";
            delActivity(this.info.activityId).then((res) => {
              if (res.code == 0) {
                this.$message.success(`活动已删除`);
                this.$router.go(-1);
              } else {
                this.$message.error(res.msg);
              }
            });
          })
          .catch(() => {});
      }
    },
    // 修改回复
    handleEditReply(reply) {
      editDiscuss(reply).then((res) => {
        if (res.code == 0) {
          this.$message.success("修改成功");
          this.currentEditReplyId = null;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 修改活动
    handleEdit() {
      this.$loading.show();
      editActivity(this.info).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          this.$message.success("修改成功");
          this.getInfo();
          this.showEdit = false;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleCommand(command) {
      this.currentSort = command;
    },
    filterName(toDiscussId) {
      let row = this.orginList.find((item) => {
        return item.discussId == toDiscussId;
      });
      if (row) return "回复 " + row.nickName;
    },
    // 回复
    handleReply(discuss, inFloor) {
      replyDiscuss({
        activityId: this.$route.query.activityId,
        msg: inFloor ? this.replyReply : this.reply,
        parentId: inFloor ? discuss.parentId : discuss.discussId,
        toDiscussId: inFloor ? discuss.discussId : null,
      }).then((res) => {
        if (res.code == 0) {
          this.$message.success("回复成功");
          this.reply = "";
          this.replyReply = "";
          this.getList();
          this.currentReplyId = null;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 点赞
    handlePraised({ praised, discussId }) {
      console.log(discussId);
      (praised ? cancelStarDiscuss : starDiscuss)(discussId).then((res) => {
        if (res.code == 0) {
          this.$message.success(praised ? "已取消点赞" : "点赞成功");
          this.getList();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 操作评论
    replyCommand(command) {
      if (command.val == 0) {
        // 编辑
        this.currentEditReplyId = command.discussId;
      } else if (command.val == 1) {
        // 删除
        this.handelDel(command.discussId);
      } else {
        // 置顶/取消置顶
        topDiscuss(command.discussId).then((res) => {
          if (res.code == 0) {
            this.$message.success(command.val == 2 ? "置顶成功" : "已取消置顶");
            this.getList();
          } else {
            this.$message.error(res.msg);
          }
        });
      }
    },
    // 删除
    handelDel(discussId) {
      this.$confirm(`确定要删除这条讨论吗？`, {
        type: "warning",
      })
        .then(() => {
          delDiscuss(discussId).then((res) => {
            if (res.code == 0) {
              this.$message.success(`删除成功`);
              this.getList();
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {});
    },
    // 回复话题
    handleReplyTopic() {
      this.$loading.show();
      replyDiscuss(this.replyTopic).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          this.$message.success("回复成功");
          this.replyTopic.msg = "";
          this.getList();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  padding: 10px 0;
  height: 100%;
  .clearfix {
    margin-bottom: 10px;
  }
  .back_box {
    float: left;
    cursor: pointer;
    img {
      width: 40px;
      height: 40px;
    }
    .text {
      margin-left: 10px;
      font-size: 16px;
      color: #999;
    }
  }
  .end_btn {
    float: right;
  }
  .main {
    height: calc(100% - 60px);
    overflow: auto;
    &::-webkit-scrollbar {
      width: 4px;
      background-color: #f5f5f5;
    }

    &::-webkit-scrollbar-track {
      box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
      border-radius: 10px;
      background-color: #f5f5f5;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
      background-color: #c8c8c8;
    }

    .topic {
      padding: 30px 50px;
      background-color: #fff;
      border-radius: 8px;
      text-align: left;
      .top {
        position: relative;
        .time {
          padding-right: 14px;
          font-size: 12px;
          color: #a8a8b3;
          border-right: 1px solid #f2f2f2;
          margin-right: 14px;
        }
        .el-icon-time {
          margin: 0 5px;
        }
        .surplus {
          font-size: 12px;
          color: sandybrown;
        }
        .end {
          color: #999;
        }

        .op {
          position: absolute;
          right: 0;
          top: 50%;
          transform: translateY(-50%);
          .el-icon-more {
            transform: rotate(90deg);
            transition: all 0.3s ease;
            cursor: pointer;
            &:hover {
              color: #1890ff;
            }
          }
        }
      }

      .content {
        margin-top: 20px;
        ::v-deep .el-textarea__inner {
          font-family: inherit;
        }
        .btn_row {
          margin-top: 16px;
          text-align: right;
        }
      }
    }

    .floors {
      margin-top: 16px;
      background-color: #fff;
      text-align: left;
      border-radius: 8px;
      .reply_title {
        height: 70px;
        line-height: 70px;
        padding: 0 30px;
        font-size: 14px;
        color: #a7a8b4;
        .op_sort {
          margin-left: 25px;
          transition: all 0.3s ease;
          cursor: pointer;
          &:hover {
            color: #1890ff;
          }
        }
      }
      .reply_list {
        .reply_item {
          padding: 20px 30px 30px 50px;
          border-bottom: solid 1px #f2f2f2;
          .noticeDetail_info {
            position: relative;
            .avatar {
              display: inline-block;
              vertical-align: middle;
              border-radius: 50%;
              margin-right: 10px;
              width: 36px;
              height: 36px;
            }
            .name {
              display: inline-block;
              vertical-align: middle;
              font-size: 14px;
              color: #646877;
            }
            .notice_interactive {
              position: absolute;
              right: 0;
              top: 50%;
              transform: translateY(-50%);
              .icon {
                font-size: 16px;
                transition: all 0.3s ease;
                cursor: pointer;
                &.like,
                &:hover {
                  color: #1890ff;
                }
                &.el-icon-more {
                  font-size: 14px;
                  transform: rotate(90deg);
                }
              }
              .num {
                margin: 0 4px;
                font-size: 14px;
                color: #91a0b5;
              }
            }
          }
          .noticeReply_right {
            padding-left: 46px;
            font-size: 14px;
            line-height: 20px;
            color: #181e33;
            .other_info {
              font-size: 12px;
              color: #a8a8b3;
              margin-bottom: 16px;
              .floor {
                margin-right: 10px;
              }
            }
            .reply_content {
              margin-bottom: 20px;
              ::v-deep .el-textarea__inner {
                font-family: inherit;
              }
              .btn_row {
                margin-top: 30px;
                text-align: right;
              }
            }
            .replyReply_container {
              background: #f7f8fa;
              border-radius: 4px;
              .replyReply {
                padding: 20px 24px 10px;
                border-bottom: solid 1px #e6ecf5;
                .replyReplyer {
                  font-size: 14px;
                  color: #646873;
                  margin-bottom: 8px;
                }
                .replyReply_content {
                  // padding-right: 30px;
                  word-break: break-word;
                  ::v-deep .el-textarea__inner {
                    font-family: inherit;
                  }
                  .btn_row {
                    margin-top: 16px;
                    text-align: right;
                  }
                }
                .info_row {
                  margin-top: 20px;
                  overflow: hidden;
                  .time {
                    float: left;
                    font-size: 12px;
                    color: #a8a8b3;
                  }
                  .btns {
                    float: right;
                    .el-button {
                      padding: 0;
                      font-size: 14px;
                      color: #91a0b5;
                    }
                  }
                }
              }
              .reply_edit {
                padding: 24px 24px 20px;
                border-radius: 4px;
                //   border: 1px solid #e6ecf5;
                &.in_floor {
                  padding: 10px 0;
                }
                .btn_row {
                  margin-top: 16px;
                  text-align: right;
                }
                ::v-deep .el-textarea__inner {
                  font-family: inherit;
                }
              }
            }
          }
        }
      }
    }

    .edit_container {
      margin-top: 16px;
      padding: 0 34px 30px;
      border-radius: 8px;
      text-align: left;
      background-color: #fff;
      .edit_headTitle {
        padding: 30px 0 20px;
        font-size: 18px;
        color: #181e33;
      }
      ::v-deep .el-textarea__inner {
        font-family: inherit;
      }
      .btn_row {
        margin-top: 30px;
        text-align: right;
      }
    }
  }
}
::v-deep .sort_item {
  &.active {
    background-color: #ecf5ff;
    color: #66b1ff;
  }
  .el-icon-check {
    visibility: hidden;
    &.show {
      visibility: visible;
    }
  }
}
</style>